import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

const FAQS = [
  { q: 'What does "premium plant-based" actually mean?', a: 'Every product is certified vegan: zero dairy, zero eggs, zero honey. We use cultured plant butters and oat-milk-based enrichments to match — and often exceed — the lamination and crumb of traditional bakery items.' },
  { q: 'How does frozen-to-oven work in practice?', a: 'Cases ship at -23°C. Your team places frozen pastries on parchment-lined trays and bakes 18–22 minutes at 165°C convection. No proofing, no thawing. Average labor: 9 seconds per pastry.' },
  { q: 'What\'s the minimum order quantity?', a: 'Campus and foodservice MOQ is one full pallet (108 cases, mix-and-match across 8 SKUs). Direct-store-delivery is available for accounts within 300 km of Toronto.' },
  { q: 'Are products nut-free / gluten-free?', a: 'Five of eight SKUs are tree-nut-free. None of our pastries are gluten-free today — our laminated dough program is wheat-based. Allergen sheets are downloadable on each product page.' },
  { q: 'Do you co-pack or private-label?', a: 'Yes — we co-pack for university dining groups and select retail brands under multi-year agreements. Reach out via the wholesale form below for an NDA-protected conversation.' },
];

export const FAQ = () => {
  return (
    <section className="relative py-24 md:py-32 bg-parchment/40">
      <div className="container mx-auto grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="font-script text-2xl text-leaf">good to know</div>
          <h2 className="font-display text-4xl sm:text-5xl text-primary font-medium leading-tight mt-1">
            Frequently<br/>asked.
          </h2>
          <p className="text-muted-foreground mt-4 text-base">
            Everything operators ask in the first call — answered up front.
          </p>
        </div>
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible defaultValue="item-0" className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`item-${i}`} className="border border-border/70 rounded-2xl bg-card px-5 data-[state=open]:shadow-card data-[state=open]:border-leaf/40 transition-all">
                <AccordionTrigger className="font-display text-base sm:text-lg text-primary hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
